import React, { useState, useEffect, useCallback } from "react";

interface CountdownState {
  days: number | string;
  hours: number | string;
  minutes: number | string;
  seconds: number | string;
}

const TimeCountDown: React.FC = () => {
  const [countdownDate] = useState<number>(new Date("06/27/2026").getTime());
  const [state, setState] = useState<CountdownState>({
    days: 0,
    hours: "00",
    minutes: "00",
    seconds: "00",
  });

  const setNewTime = useCallback(() => {
    const currentTime = new Date().getTime();
    const distanceToDate = countdownDate - currentTime;

    if (distanceToDate <= 0) {
      setState({ days: 0, hours: "00", minutes: "00", seconds: "00" });
      return;
    }

    let days = Math.floor(distanceToDate / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distanceToDate % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distanceToDate % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distanceToDate % (1000 * 60)) / 1000);

    const padZero = (num: number) => (num < 10 ? `0${num}` : num);

    setState({
      days,
      hours: padZero(hours),
      minutes: padZero(minutes),
      seconds: padZero(seconds),
    });
  }, [countdownDate]);

  useEffect(() => {
    const intervalId = setInterval(setNewTime, 1000);
    return () => clearInterval(intervalId);
  }, [setNewTime]);

  return (
    <div className="react-countdown">
      <div className="time-section">
        <div className="time">{state.days}</div>
        <small className="time-text">Días</small>
      </div>
      <div className="time-section">
        <div className="time">{state.hours}</div>
        <small className="time-text">Hor</small>
      </div>
      <div className="time-section">
        <div className="time">{state.minutes}</div>
        <small className="time-text">Min</small>
      </div>
      <div className="time-section">
        <div className="time">{state.seconds}</div>
        <small className="time-text">Seg</small>
      </div>
    </div>
  );
};

export default TimeCountDown;
